import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import OperatorApplicationDialogHistory
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogHistory.vue";
import {nextTick, ref} from "vue";
import {__} from "~/ts/library/Translate";
import Delay from "~/ts/library/Delay";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "OperatorClientHistoryPreviewDialog"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    userdata: {}
  }, {
    "visible": { type: Boolean, ...{
    required: true
} },
    "visibleModifiers": {},
  }),
  emits: ["update:visible"],
  setup(__props: any) {

let props = __props;

let markAsReadedEnabled = ref(false);

let visibleModel = _useModel<boolean>(__props, "visible");

function markAsReaded() {
    markAsReadedEnabled.value = true;
    nextTick(async () => {
        await Delay.make(100);
        visibleModel.value = false;
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_unref(visibleModel))
    ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: _unref(visibleModel),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visibleModel) ? (visibleModel).value = $event : visibleModel = $event)),
        title: _unref(props).userdata.displayDescr,
        class: "right w-50 overflow full-height-body",
        "body-class": "p-1"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_el_button, { onClick: markAsReaded }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(__)('Пометить как прочитанное')), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(OperatorApplicationDialogHistory, {
            class: "h-100",
            userdata: __props.userdata,
            "mark-as-readed-enabled": _unref(markAsReadedEnabled)
          }, null, 8, ["userdata", "mark-as-readed-enabled"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]))
    : _createCommentVNode("", true)
}
}

})